import { render } from "./App.vue?vue&type=template&id=2a3dcd5e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2a3dcd5e&lang=css"
script.render = render

export default script